<template>
  <div class="container">
    <div class="container-box">
      <div class="sign">
        <div class="sign-box">
          <img src="../../assets/home/bi.png" class="sign-bi" />
          <div class="sign-num">{{gold}}</div>
        </div>
      </div>

      <div class="sign-day">
        <div class="top-font c9">已连续签到</div>
        <div class="ser">
          <span class="day-font">{{ day }}</span>
          <span class="day">天</span>
        </div>
        <div class="top-font bottom-font c9">每天都有好运气</div>
      </div>

      <div class="sign-content">
        <div class="content">
          <div class="c9">连续签到即可获得更多的奖励</div>
          <div class="sign-circle">
            <div class="liner-box">
              <img src="../../assets/home/liner.png" class="liner" />
            </div>
            <div
              class="sign-circle-item"
              v-for="(item, index) in signList"
              :key="index"
              @click="sign(item, index)"
            >
              <div class="c-box" :class="index == 0 &&
                      ((day < 1 && isSingIn == 0) ||
                        (day >= 1 && isSingIn == 1)) ? 'y-n' : ''">
                <!-- 今天未签 -->
                <img
                  src="../../assets/home/circal0.png"
                  class="c-img"
                  v-if="index == 1 && item.isSign == 0"
                />
                <!-- 明天 -->
                <img
                  src="../../assets/home/circal1.png"
                  class="c-img"
                  v-if="index > 1"
                />
                <!-- 已签 -->
                <img
                  src="../../assets/home/circal2.png"
                  class="c-img"
                  v-if="
                    (index == 1 && item.isSign == 1) ||
                    (index == 0 && ((isSingIn == 1 && day > 1) || (isSingIn == 0 && day > 0)))
                  "
                />
                <!-- 未签 -->
                <img
                  src="../../assets/home/n.png"
                  class="c-img"
                  v-if="
                    index == 0 &&
                      ((day < 1 && isSingIn == 0) ||
                        (day >= 1 && isSingIn == 1))
                  "
                />
                <span
                  class="c-f"
                  v-if="index > 1 || (index == 1 && item.isSign == 0)"
                  >+{{ item.num }}</span
                >
              </div>
              <div class="cir-font" :class="index == 1 ? 'isday' : ''">
                <img
                  src="../../assets/home/c0.png"
                  v-if="index == 1"
                  class="c-img"
                />
                <img
                  src="../../assets/home/c2.png"
                  v-else-if="index == 0"
                  class="c-img"
                />
                <img src="../../assets/home/c1.png" v-else class="c-img" />
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="coupon">
        <div
          class="coupon-item"
          :class="item.type == 2 ? 'isget' : item.type == 1 ? 'unget' : 'geting'"
          v-for='(item,index) in coupon' :key="index"
          @click="getCoupon(item)"
        >
          <img src="../../assets/home/c-b1.png" class="coupon-img" v-if="item.type != 2" />
          <img src="../../assets/home/c-b3.png" class="coupon-img" v-else />
          <div class="coupon-content">
            <div class="num"><span>￥</span>{{item.price}}</div>
            <div class="font2">{{item.name}}</div>
            <div class="font2 font3">连续签到{{item.day}}日</div>
          </div>
          <div class="btn">
            {{item.type == 0 ? '未达成' : item.type == 1 ? '点击领取' : '已领取'}}
          </div>
        </div>
      </div>
      <div class="font">
        每日签到可获得1金币。连续签到奖励：连续7日签到，每日可获得2金币。
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isDay: 1,
      flag: true,
      signList: [],
      day: 0, //连续签到天数
      coupon: [],
      isSingIn: false, //今天是否签到
      user:{},
      gold:0
    };
  },
  methods: {
    sign(item, index) {
      if (!this.flag) return;
      if (index != 1 || (index == 1 && item.isSign == 1)) return;
      this.flag = false;
      this.api.signIn().then(() => {
        this.Toast.success("签到成功");
        this.gold = Number(this.gold) + item.num;
        this.user.gold = this.gold;
        localStorage.setItem('user',JSON.stringify(this.user))
        this.getMsg();
        this.flag = true;
      });
    },
    getCoupon(item){
      if(item.type != 1) return;
      this.api.receiveSignCoupon({id:item.id}).then(() => {
        this.Toast.success("领取成功");
        this.getMsg();
      })
    },
    getMsg() {
      this.api.getSignInfo().then((res) => {
        let arr = res.data.arr;
        this.day = res.data.day;
        this.coupon = res.data.coupons;
        let d = new Date();
        this.signList = [];
        this.isSingIn = res.data.isSingIn;
        for (let i = 1; i <= 7; i++) {
          let name = d.getMonth() + 1 + "-" + (d.getDate() + i - 2);
          let obj = {
            name: name,
            num: 1,
            isSign: 0,
            today: false,
          };
          if (i == 1 && this.day > 1) {
            obj.isSign = 1;
            obj.name = "昨天";
          }
          if (i == 2) {
            obj.today = true;
            obj.name = "今天";
            obj.isSign = res.data.isSingIn;
          }
          if (i > 1) {
            obj.num = arr[i - 2];
          }
          this.signList.push(obj);
        }
      });
    },
  },
  created() {
    this.flag = true;
    this.gold = JSON.parse(localStorage.getItem('user')).gold;
    this.user = JSON.parse(localStorage.getItem('user'))
    this.gold = this.gold ? this.gold : 0
    this.getMsg();
  },
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background: url("../../assets/home/sign_bg.png") no-repeat;
  background-size: 100% 100%;
  padding-bottom: 0.2rem;
  box-sizing: border-box;
  .container-box {
    padding-top: 0.6rem;
  }
}
.c9 {
  color: #999;
}
.sign {
  display: flex;
  justify-content: flex-end;
  padding-right: 0.24rem;
  margin-bottom: 0.46rem;
}
.sign-box {
  position: relative;
  border-radius: 0.24rem;
  line-height: 0.48rem;
  height: 0.48rem;
  background: rgba($color: #000000, $alpha: 0.5);
  font-size: 0.24rem;
  padding: 0 0.4rem 0 0.5rem;
  color: #f3b953;
  .sign-bi {
    width: 0.38rem;
    position: absolute;
    left: 0.05rem;
    top: 50%;
    transform: translateY(-50%);
  }
  .sign-num {
    // width: 0.5rem;
    text-align: center;
    min-width: 0.5rem;
  }
}
.sign-day {
  width: 2.62rem;
  height: 2.94rem;
  background: url("../../assets/home/sign-box.png") center center no-repeat;
  background-size: 100%;
  margin: 0 auto;
  padding-top: 0.9rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 0.18rem;
  .top-font {
    font-size: 0.22rem;
    margin-bottom: 0.2rem;
  }
  .bottom-font {
    margin-bottom: 0;
  }
  .ser {
    margin-bottom: 0.1rem;
    .day-font {
      font-size: 0.8rem;
      font-weight: bold;
    }
    .day {
      font-size: 0.24rem;
    }
  }
}
.sign-content {
  padding: 0 0.3rem;
  .content {
    background: #fff;
    padding: 0.25rem;
    border-radius: 0.15rem;
    font-size: 0.24rem;
    .c9 {
      padding-bottom: 0.4rem;
    }
    .sign-circle {
      display: flex;
      justify-content: space-between;
      position: relative;
      .liner-box {
        position: absolute;
        top: 1.12rem;
        left: 0;
        width: 100%;
        height: 0.04rem;
        // background: #000;
        padding: 0 0.42rem;
        box-sizing: border-box;
        z-index: 0;
        .liner {
          width: 100%;
          display: block;
        }
      }

      .sign-circle-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .c-box {
          margin-bottom: 0.22rem;
          display: flex;
          position: relative;
          width: 0.82rem;
          height: 0.82rem;
          align-items: center;
          justify-content: center;
          font-size: 0.3rem;
          color: #fff;
          &.y-n {
            background: #bbb;
            border-radius: 50%;
          }
          .c-f {
            z-index: 1;
          }
          .c-img {
            z-index: 0;
            position: absolute;
            top: 0;
            left: 0;
            width: 0.82rem;
            height: 0.82rem;
            text-align: center;
          }
        }
      }
      .cir-font {
        display: flex;
        align-items: center;
        flex-direction: column;
        color: #999;
        &.isday {
          color: #333;
        }
        .c-img {
          width: 0.18rem;
          display: block;
          margin-bottom: 0.1rem;
          z-index: 2;
        }
      }
    }
  }
}
.coupon {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  
  padding: 0.24rem;
  .coupon-item {
    margin-bottom: 0.2rem;
    width: 2.22rem;
    height: 3.12rem;
    position: relative;
    padding-top: 0.6rem;
    text-align: center;
    box-sizing: border-box;
    z-index: 2;
    .coupon-content {
      position: relative;
      margin-bottom: 0.6rem;
      .num {
        position: relative;
        font-size: 0.6rem;
        span {
          font-size: 0.15rem;
        }
      }
      .font2 {
        font-size: 0.24rem;
      }
    }
    .btn {
      z-index: 2;
      position: relative;
      font-size: 0.24rem;
      color: #fff;
    }
    &.isget {
      color: #bbb;
    }
    &.unget {
      color: #fe7f43;
      .font3 {
        color: #666;
      }
    }
    &.geting {
      color: #fe7f43;
      opacity: 0.5;
      .font3 {
        color: #666;
      }
    }
    .coupon-img {
      width: 2.22rem;
      height: 3.12rem;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
    }
  }
}
.font {
  color: #fff;
  font-size: 0.24rem;
  padding: 0 0.46rem;
}
</style>
